//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ImageModal from "@/components/objects/ImageModal.vue";
import { AttrsListItem } from "@/utils/dto/objects.js";
import { BUILD_STORAGE_IMAGE_PATH } from "@/constants/ui.js";
import { adjustColorBrightness, buildMaskStyle } from "@/utils/helpers.js";
import TheMaskIcon from '@/components/objects/TheMaskIcon.vue';

export default {
  name: "ImageWithDetail",
  components: { TheMaskIcon },
  props: {
    item: {
      type: [Object, AttrsListItem],
      default: () => {
        return {
          id: "",
          label: "",
          text: ""
        }
      }
    },
    objectId: {
      type: String
    },
    direction: {
      type: String
    },
    detail: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number
    },
    expandId: {
      type: String
    },
    useStorage: {
      type: Boolean
    },
    mask: {
      type: String
    },
    textColor: {
      type: [String, null],
      default: null
    },
    bgColor: {
      type: String
    },
    bgGradientEnabled: {
      type: Boolean,
    },
    bgGradientDirection: {
      type: String,
      default: 'bottom'
    },
    bgGradientShadowDirection: {
      type: String,
      default: 'transparent'
    },
  },
  data() {
    return {
      textClamp: true,
      latestWindowWidth: 0
    }
  },
  computed: {
    getBg() {
      if (this.bgGradientEnabled && this.bgColor) {
        return `linear-gradient(to ${this.bgGradientDirection}, ${this.bgGradientShadowDirection === 'transparent' ? `${this.bgColor}, transparent` : `${this.bgColor}, ${adjustColorBrightness((this.bgColor), 1.20)}`})`
      } else if (this.bgColor) {
        return this.bgColor;
      }

      // switch (this.direction) {
      // case 'to-left':
      // case 'to-right':
      //   return 'linear-gradient(90deg, #F0FAFF 0%, #D6F0FF 100%)';
      // case 'to-bottom':
      //   return 'linear-gradient(0, #F0FAFF 0%, #D6F0FF 100%)';
      // case 'to-top':
      //   return 'linear-gradient(180deg, #F0FAFF 0%, #D6F0FF 100%)';
      // }

      return null;
    },
    rowSize() {
      return this.detail ? 2 : 3
    },
    directionIndex() {
      return (this.index + 1) % this.rowSize
    },
    isSecond() {
      return !this.detail && this.index > 0 && (this.index + 1) % this.rowSize === 0
    },
    isBottom() {
      return this.detail ? this.directionIndex === 0 : this.directionIndex === 2
    },
    highlight() {
      return this.$route.hash === `#${this.item.id}`
    },
    currentText() {
      return this.expand || this.detail ? this.item.fullText : this.item.shortText
    },
    expand() {
      return this.item.id === this.expandId
    },
    imagePath() {
      if (this.useStorage) {
        return BUILD_STORAGE_IMAGE_PATH(this.item.image_file)
      } else {
        return `/public/object_attrs_files/${this.objectId}/${this.item.id}/`
      }
    }
  },
  watch: {
    detail() {
      this.$nextTick(() => {
        this.resizeHandler(true)
      })
    }
  },
  mounted() {
    window.addEventListener('resize', this.resizeHandler, { passive: true })
    this.$nextTick(this.resizeHandler)
  },
  destroyed() {
    window.removeEventListener('resize', this.resizeHandler)
  },
  methods: {
    maskStyle(mask) {
      return buildMaskStyle(mask)
    },
    resizeHandler(force = false) {
      if (this.latestWindowWidth === window.innerWidth && !force) return
      this.latestWindowWidth = window.innerWidth
      this.$emit('expand', '')

      const STYLE_BOX = getComputedStyle(this.$refs['text-box'])
      const STYLE_BOX_HEIGHT = Math.floor(this.$refs['text-box'].clientHeight - (parseFloat(STYLE_BOX.paddingBottom) + parseFloat(STYLE_BOX.paddingTop)))
      const REAL_HEIGHT_FOR_TEXT = Math.floor(STYLE_BOX_HEIGHT - (this.$refs.title.clientHeight + 12))
      this.$refs['text-box'].style.setProperty(
        '--line-clamp',
        Math.floor(REAL_HEIGHT_FOR_TEXT / parseInt(getComputedStyle(this.$refs.text).lineHeight))
      )
      let boxHeight = this.$refs['text-box'].clientHeight

      if (this.detail) boxHeight = this.$refs['item'].clientHeight

      this.$refs['text-box'].style.setProperty('--box-height', `${boxHeight}px`)
      this.textClamp = Boolean(this.$refs.text.scrollHeight > REAL_HEIGHT_FOR_TEXT || this.currentText.length < this.item.fullText.length)
    },
    handleSelfExpand() {
      if (window.innerWidth >= 639 || !this.textClamp || this.detail) return

      if (this.expand) {
        this.$emit('expand', '')
      } else {
        this.$emit('expand', this.item.id)
      }
    },
    openPopup() {
      this.$vfm.show({
        component: ImageModal,
        bind: {
          src: this.$addServerPath(this.imagePath),
          label: this.item.label || "Без названия",
          source: this.item.image_url
        },
        on: {
          'before-open': () => {
            this.isOpen = true
          },
          'closed': () => {
            this.isOpen = false
          }
        }
      })
    }
  }
}
